import type { PropsWithChildren } from 'react';
import React from 'react';
import cn from 'classnames';
import * as styles from './styles.module.css';

// используется внутри BaseContainer, если на мобилке нужно сделать fullwidth блок
export function FullWidthBlock({
  children,
  className = '',
}: PropsWithChildren<{ className?: string }>) {
  return <div className={cn([styles.fullWidthBlock, className])}>{children}</div>;
}
